








import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import CampaignContactStatusEnum from '@/models/CampaignContacts/CampaignContactStatus';


@Component({
  name: 'CampaignContactStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	status: CampaignContactStatusEnum;

	get pending() {
		return this.hasStatus(CampaignContactStatusEnum.Pending);
	}

	get skipped() {
		return this.hasStatus(CampaignContactStatusEnum.Skipped);
	}

	get processed() {
		return this.hasStatus(CampaignContactStatusEnum.Processed);
	}

	hasStatus(status: CampaignContactStatusEnum) {
		if (this.status === status) {
			return true
		}
		return false;
	}
}
